<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import confirmationImage from 'dashboard/assets/images/sales-registration-intro.png';

const emit = defineEmits(['close']);
const { t } = useI18n();
</script>

<template>
  <section
    data-testid="post-sale-deed-feedback-confirmation"
    class="relative grid gap-0 lg:grid-cols-[minmax(0,412px)_minmax(0,1fr)] lg:items-stretch"
  >
    <button
      type="button"
      class="absolute right-0 top-0 z-10 hidden size-9 place-items-center rounded-full text-lais-text-muted hover:bg-lais-primary-50 focus-visible:outline-none focus-visible:shadow-lais-focus lg:grid"
      :aria-label="t('POST_SALE.DEED_FEEDBACK.SUCCESS.CLOSE')"
      data-testid="post-sale-deed-feedback-desktop-close"
      @click="emit('close')"
    >
      <span class="i-lucide-x size-4" aria-hidden="true" />
    </button>
    <div class="relative flex justify-center lg:justify-start">
      <button
        type="button"
        class="absolute right-2 top-2 z-10 grid size-9 place-items-center rounded-full text-lais-text-muted hover:bg-lais-primary-50 focus-visible:outline-none focus-visible:shadow-lais-focus lg:hidden"
        :aria-label="t('POST_SALE.DEED_FEEDBACK.SUCCESS.CLOSE')"
        data-testid="post-sale-deed-feedback-mobile-close"
        @click="emit('close')"
      >
        <span class="i-lucide-x size-4" aria-hidden="true" />
      </button>
      <img
        :src="confirmationImage"
        :alt="t('POST_SALE.DEED_FEEDBACK.SUCCESS.IMAGE_ALT')"
        class="h-auto w-full object-contain lg:max-h-[533px] lg:w-auto lg:max-w-full"
        data-testid="post-sale-deed-feedback-confirmation-image"
      />
    </div>
    <div
      data-testid="post-sale-deed-feedback-confirmation-content"
      class="flex min-w-0 flex-col justify-between px-5 py-5 lg:min-h-[533px] lg:pb-[50px] lg:pl-[90px] lg:pr-[25px] lg:pt-[50px]"
    >
      <div>
        <h2
          class="font-redHatDisplay text-2xl font-bold leading-[30px] text-lais-text lg:w-[317px] lg:text-[40px] lg:leading-[42px]"
        >
          {{ t('POST_SALE.DEED_FEEDBACK.SUCCESS.TITLE') }}
        </h2>
        <div class="mt-[25px] text-base leading-6 text-lais-text">
          <p>{{ t('POST_SALE.DEED_FEEDBACK.SUCCESS.DESCRIPTION') }}</p>
        </div>
      </div>
      <div class="mt-[30px] flex w-full justify-end lg:mt-0">
        <LaisPrimaryButton
          size="md"
          data-testid="post-sale-deed-feedback-confirm"
          @click="emit('close')"
        >
          {{ t('POST_SALE.DEED_FEEDBACK.SUCCESS.CONFIRM') }}
        </LaisPrimaryButton>
      </div>
    </div>
  </section>
</template>
